import { getCdpDataService,saveCdpDataService } from '../../services/cdpservice';
import { fetchCdpDataRequest, fetchCdpDataSuccess, fetchCdpDataFailure,saveCdpDataRequest,saveCdpDataFailure,saveCdpDataSuccess } from '../actions/cdpActions';

export const getCdpData = (supplierId) => {
  return async (dispatch) => {
    dispatch(fetchCdpDataRequest());
    try {
      const data = await getCdpDataService(supplierId);
      dispatch(fetchCdpDataSuccess(data));
    } catch (error) {
      dispatch(fetchCdpDataFailure(error.message));
    }
  };
}
export const saveCdpData = (cdpData,supplierId) => {
  return async (dispatch) => {
    dispatch(saveCdpDataRequest()); // Update to use saveCdpDataRequest
    try {
      // Pass the cdpData to the service that saves the data
      const response = await saveCdpDataService(cdpData,supplierId); // Assuming saveCdpDataService is your API call
      dispatch(saveCdpDataSuccess(response));
    } catch (error) {
      dispatch(saveCdpDataFailure(error.message));
    }
  };
}